import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            探索分类
          </h2>
          <p className="text-sm text-foreground-500 mt-3">找到你感兴趣的内容领域，发现更多精彩视频</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-[oklch(var(--primary-500)/0.3)] transition-all duration-300 hover:bg-background-50"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 ${cat.color}`}>
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mb-2">{cat.description}</p>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-3 py-1 rounded-full">
                {cat.videoCount.toLocaleString()} 个视频
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}